import Image from 'next/image'
import React from 'react'
import clsx from 'clsx'

interface SourceIconProps {
  sourceIcon?: string | null
  sourceName?: string | null
  domain?: string | null
  containerClassName?: string
  imageClassName?: string
  imageHeight?: number
  imageWidth?: number
}

const SourceIcon: React.FC<SourceIconProps> = ({
  sourceIcon,
  sourceName,
  domain,
  containerClassName = '',
  imageClassName = '',
  imageHeight,
  imageWidth,
}) => {
  // Don't render if we don't have a good icon
  if (!sourceIcon) {
    return null
  }

  return (
    <div className={clsx('', containerClassName)}>
      <Image
        src={sourceIcon}
        alt={sourceName || ''}
        unoptimized
        width={imageWidth || 16}
        height={imageHeight || 16}
        className={clsx('', imageClassName)}
        onError={(e) => {
          // Fallback to Google favicon service if original fails
          const target = e.target as HTMLImageElement

          if (!!domain) {
            target.src = `https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${domain}&size=96`
          }
        }}
      />
    </div>
  )
}

export default SourceIcon
